import {
    useEffect,
    useRef,
    useState
} from "react";
import {
    ImageEntity,
    ResolvedImageEntity
} from "../types/ImageEntity";

export const useResolveImageEntity = (imageEntities: Array<ImageEntity>) => {
    const [resolvedImageEntities, setResolvedImageEntities] = useState<Array<ResolvedImageEntity> | undefined>(undefined);
    const isMounted = useRef(true);

    useEffect(() => {
        isMounted.current = true;
        const resolvedImageEntities = async () => {
            const settledImageEntities: Array<PromiseSettledResult<ResolvedImageEntity>> = await Promise.allSettled(imageEntities.map(async (image) => {
                const resolvedUrls = Object.entries(image.urls).map(async ([key, url]) => {
                    return [key, typeof url === 'function' ? await url() : url];
                });
                const resolvedUrlsObject = Object.fromEntries(await Promise.all(resolvedUrls));
                return {
                    ...image,
                    urls: resolvedUrlsObject
                } satisfies ResolvedImageEntity;
            }));
            if (!isMounted.current) {
                return;
            }
            const fulfilledImageEntities = settledImageEntities
                .filter((resolvedEntity) => resolvedEntity.status === 'fulfilled')
                .map((resolvedEntity) => (resolvedEntity as PromiseFulfilledResult<ResolvedImageEntity>).value);
            setResolvedImageEntities(fulfilledImageEntities);
        };
        resolvedImageEntities();
        return () => {
            isMounted.current = false;
        };
    }, [imageEntities]);

    return {
        resolvedImageEntities
    };
};